import { Instagram, Mail, Phone } from "lucide-react";
import { BrandMark } from "@/components/site/BrandMark";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[color:var(--nr-bg-soft)] border-t border-[color:var(--nr-line)] pt-20 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <div className="flex flex-col items-start gap-3 mb-6">
              <BrandMark className="w-11 h-11 text-[color:var(--nr-accent)]" />
              <div>
                <div className="font-serif-display text-3xl text-[color:var(--nr-ink)] leading-none">
                  noah<span className="text-[color:var(--nr-accent)]">+</span>rayn
                </div>
                <div className="text-xs uppercase tracking-[0.2em] text-[color:var(--nr-ink-soft)] mt-2">
                  Pte Ltd
                </div>
              </div>
            </div>
            <p className="font-serif-display italic text-2xl text-[color:var(--nr-ink)] leading-snug max-w-sm">
              — building meaningful spaces —
            </p>
            <p className="mt-6 text-sm text-[color:var(--nr-ink-soft)] max-w-md leading-relaxed">
              A Singapore home renovation studio for Resale & BTO flats.
              Honest pricing, craft-first delivery, family-led care.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-[color:var(--nr-ink-soft)] mb-5">
              Explore
            </div>
            <ul className="space-y-3 text-[color:var(--nr-ink)] font-serif-display text-lg">
              {[
                ["Our Story", "#about"],
                ["Services", "#services"],
                ["Portfolio", "#portfolio"],
                ["Why Us", "#why"],
                ["Voices", "#testimonials"],
                ["Contact", "#contact"],
              ].map(([l, h]) => (
                <li key={h}>
                  <a href={h} className="link-underline">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.2em] text-[color:var(--nr-ink-soft)] mb-5">
              Speak with us
            </div>
            <ul className="space-y-4">
              <li>
                <a
                  href="https://wa.me/6589867250"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-[color:var(--nr-ink)]"
                  data-testid="footer-whatsapp-1"
                >
                  <Phone size={16} className="text-[color:var(--nr-accent)]" />
                  <span className="font-serif-display text-lg">+65 8986 7250</span>
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/6588982967"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-[color:var(--nr-ink)]"
                  data-testid="footer-whatsapp-2"
                >
                  <Phone size={16} className="text-[color:var(--nr-accent)]" />
                  <span className="font-serif-display text-lg">+65 8898 2967</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:contactus@noahandrayn.com.sg"
                  className="flex items-center gap-3 text-[color:var(--nr-ink)]"
                  data-testid="footer-email"
                >
                  <Mail size={16} className="text-[color:var(--nr-accent)]" />
                  <span className="font-serif-display text-lg">
                    contactus@noahandrayn.com.sg
                  </span>
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/noahandrayn"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-[color:var(--nr-ink)]"
                  data-testid="footer-instagram"
                >
                  <Instagram size={16} className="text-[color:var(--nr-accent)]" />
                  <span className="font-serif-display text-lg">@Noahandrayn</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="nr-rule mb-6" />
        <div className="flex flex-col sm:flex-row justify-between gap-3 text-xs text-[color:var(--nr-ink-soft)]">
          <div>© {new Date().getFullYear()} Noah+Rayn Pte Ltd. All rights reserved.</div>
          <div className="italic">In partnership with Awi Rafael — music, design, home.</div>
        </div>
      </div>
    </footer>
  );
};
